import { createRouteContextObject } from '@shared/utils';
import { HttpContextBase } from '..';

enum HttpContextRoutes {
  //Activities
  GetActivities,
  SyncActivities,

  //Activity Groups
  GetActivityGroups,
  SyncActivityGroups,

  //Activity Streams
  GetActivityStreams,
  GetActivityStreamsWithTerminologies,
  SyncActivityStreams,

  //Approvers
  GetApprovers,
  SyncApprovers,

  //Consumables
  GetConsumables,
  SyncConsumables,

  //Custom-Data
  GetCustomData,
  SyncCustomData,

  //Filenames
  GetFilenames,
  SyncFilenames,

  //FreeTextFields
  GetFreeTextFields,
  SyncFreeTextFields,

  //HiddenSubtabs
  GetHiddenSubtabs,
  SyncHiddenSubtabs,

  //HSE
  GetHse,
  SyncHse,

  //LocationCategories
  GetLocationCategories,
  SyncLocationCategories,

  //Locations
  GetLocations,
  SyncLocations,

  //Personnel
  GetPersonnel,
  SyncPersonnel,

  //ProgressWithoutTarget
  GetProgressWithoutTarget,
  SyncProgressWithoutTarget,

  //Progress
  GetProgress,
  SyncProgress,

  //ProjectSetupConfiguration
  GetConfiguration,
  GetClientInfo,
  SyncConfiguration,

  //ReleaseSubproject
  ReleaseSubproject,

  //ReportConfiguration
  GetReportConfiguration,
  SyncReportConfiguration,

  //StatusTracker
  GetStatusTracker,
  SyncStatusTracker,

  //TableOfColumns
  GetTableOfColumns,
  SyncTableOfColumns,

  //Terminologies
  GetTerminologies,
  GetSubprojectTerminologies,

  //Weather
  GetWeather,
  SyncWeather,

  //ForecastCategories
  GetForecastCategories,
  SyncForecastCategories,
}

export const HttpProjectSetupContext = createRouteContextObject(
  HttpContextBase.ProjectSetup,
  HttpContextRoutes
);
